import { httpBackOfficeUtil } from "./httpBackOfficeUtil"
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil"
import { calculateUnixTimestamp, formatDateToDDMMYYYYFrEpoch} from "../../utils/util"

export const activities = {
    getActivitiesType,
    getActivities,
    updateActivity,
    getActivity,
    updateActivityCustomFields,
    listActivityByCustomerAndOrder,
    addNoteActivity,
    getListNoteActivity
}

async function getActivitiesType({
    page = 1,
    size = 10,
    state = "ACTIVE",
    search_value,
    include_total = true,

} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities/types',
            queryParams: {
                page,
                size,
                state,
                search_value,
                include_total
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivitiesType: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getActivities({
    page = 1,
    size = 10,
    type_id,
    order_id,
    include_total = true,
    include_custom_fields= true,
    state='PENDING,COMPLETED',
    sort,
    order
} = {},) {
    try {
        let id = httpBackOfficeUtil.getSession().sub;
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities',
            queryParams: {
                page,
                size,
                type_id,
                order_id,
                include_total,
                include_custom_fields,
                assigned_to_user_id: id,
                state,
                sort,
                order
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivities: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getActivity(activityId) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: `/v2/activities/${activityId}`,
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getActivitie: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateActivity({
    activity_id,
    state,
    custom_fields,
    date,
    scheduledTimeFrom,
    scheduledTimeTo,
} = {}) {
    try {
        let scheduledDate = null;
        try {
            if(date){
                const dtStr = formatDateToDDMMYYYYFrEpoch(date, true);
                console.log('updateActivity dtStr: ', dtStr);
                const dtArr = dtStr.split('/');
                // scheduledDate = ((new Date(parseInt(dtArr[0]), parseInt(dtArr[1])-1, parseInt(dtArr[2]) - 1, 20,0,0,0)).getTime()) / 1000;
                //CRM automatically convert to UTC so it does not present the selected value from local (Greendot side)
                //but when CRM displays the scheduled date on CRM page it will keep the UTC value while it displays local time for created_date
                const year = parseInt(dtArr[2]);
                const month = parseInt(dtArr[1]); // Months are 1-indexed, so June is 6
                const day = parseInt(dtArr[0]);
                const hour = 0;
                const minute = 0;
                const second = 1;
                
                // Calculate the timestamp value
                scheduledDate = calculateUnixTimestamp(year, month, day, hour, minute, second);                
                console.log('updateActivity scheduledDate: ', scheduledDate);
            }    
        } catch (error) {
            console.log("updateActivity convert scheduled_date fail: ", error);
        }

        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/activities/' + activity_id,
            withAccessToken: true,
            body: {
                state,
                custom_fields,
                date: scheduledDate,
                from_time: scheduledTimeFrom,
                to_time: scheduledTimeTo
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("AAAA updateActivity: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function updateActivityCustomFields({
    activity_id,
    custom_fields
} = {}) {
    try {
        let response = await httpBackOfficeUtil.put({
            resourcePath: '/v2/activities/' + activity_id,
            withAccessToken: true,
            body: {
                custom_fields
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("updateActivityCustomFields: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}

async function listActivityByCustomerAndOrder({
    page = 1,
    size = 10,
    contact_id, 
    order_id,
    state='COMPLETED'
} = {},) {
    try {
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities',
            queryParams: {
                page,
                size,
                contact_id,
                order_id,
                state
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception listActivityByCustomerAndOrder: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addNoteActivity({
    activity_id,
    note
} = {}) {
    try {
        let response = await httpBackOfficeUtil.post({
            resourcePath: '/v2/activities/' + activity_id + '/notes',
            withAccessToken: true,
            body: {
                note:note
            },
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("updateActivityCustomFields: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}
async function getListNoteActivity({
    activity_id,
    page = 1,
    size = 10,
    include_total = true,
    order="ASC"
} = {}) {
    try {
        
        let response = await httpBackOfficeUtil.get({
            resourcePath: '/v2/activities/' + activity_id + '/notes',
            withAccessToken: true,
            queryParams:{
                page,
                size,
                include_total,
                order
            }
        });
        return createCommonResult(response);
    } catch (error) {
        console.log("updateActivityCustomFields: ", error)
        return createResult(ErrorCodes.UNKNOWN, error)
    }
}